import {Document} from "components/View/document";
import React from "react";
import FormRow from "v4/components/form/FormRender/components/FormRow/FormRow";
import InlineLoader from "v4/components/ui/InlineLoader/InlineLoader";
import Loader from "v4/components/ui/Loader/Loader";
import FormRender from "v4/components/form/FormRender/FormRender";

import 'v4/features/front/generatePdf/components/GeneratePdf/GeneratePdf.scss'
import useGeneratePdf from "v4/features/front/generatePdf/components/GeneratePdf/hooks/useGeneratePdf";
import {usePolTranslation} from "v4/hooks/usePolTranslation";

export default function GeneratePdf({toggleGeneratePopup, preselectTemplateId, quoteId, updateHandler}) {
    const {t} = usePolTranslation();

    const {
        form,
        methods,
        isLoading,
        isLoadingGenerate,
        isFilenameDisabled,
        pdfFile,
        handleSubmit,
    } = useGeneratePdf({quoteId, preselectTemplateId, updateHandler});

    if (isLoading) {
        return <InlineLoader/>
    }

    return (
        <>
            {!pdfFile && form && (
                <FormRender form={form}
                            methods={methods}
                            onSubmit={handleSubmit}
                            formClassName="pt-2"
                            hasToHideRest
                >
                    <FormRow fieldName="template"/>
                    <FormRow fieldName="showPrices"/>
                    <FormRow fieldName="filename" overrideField={{attr: {disabled: isFilenameDisabled}}}/>

                    <div className="quotes-generate-pdf__body__buttons">
                        <button type="button"
                                className="quotes-generate-pdf__body__buttons-return"
                                onClick={toggleGeneratePopup}>
                            {t('cancel')}
                        </button>
                        <button type="submit"
                                className="quotes-generate-pdf__body__buttons-validate">
                            {t('generate')}
                        </button>
                    </div>
                </FormRender>
            )}

            {isLoadingGenerate && (
                <div className="quotes-generate-pdf__loader">
                    <Loader/>
                </div>
            )}

            {pdfFile && (
                <>
                    <Document doc={pdfFile} hasShow/>
                    <div className="quotes-generate-pdf__body__buttons">
                        <button className={'quotes-generate-pdf__body__buttons-return'}
                                onClick={toggleGeneratePopup}>
                            {t('close')}
                        </button>
                    </div>
                </>
            )}
        </>
    )
}
